import styled, { css } from 'styled-components';

import Pagination from '@material-ui/lab/Pagination';

import { Link } from 'react-router-dom';
import { ReactComponent as IconSearchSVG } from '../../../assets/icons/icon-search.svg';
import { ReactComponent as IconMoreSVG } from '../../../assets/icons/icon-more.svg';
import { ReactComponent as IconDeleteSVG } from '../../../assets/icons/icon-delete.svg';
import { ReactComponent as IconSMArrowDownSVG } from '../../../assets/icons/icon-sm-arrow-down.svg';

import { ReactComponent as IconHeatmapSVG } from '../../../assets/icons/icon-heatmap.svg';
import { ReactComponent as IconUserflowSVG } from '../../../assets/icons/icon-userflow.svg';

// icon
export const IconSearch = styled(IconSearchSVG)`
  position: absolute;
  width: 18px;
  height: 18px;
  top: 8px;
  right: 16px;
  cursor: pointer;
`;

export const IconSMArrowDown = styled(IconSMArrowDownSVG)<{
  $isDescending: boolean;
}>`
  ${(props) => {
    if (props.$isDescending) {
      return css``;
    }
    return css`
      transform: rotate(180deg);
    `;
  }}
`;

export const IconDelete = styled(IconDeleteSVG)`
  margin-left: 24px;
  margin-right: 24px;
  width: 18px;
  height: 18px;

  cursor: pointer;
`;
export const IconHeatmap = styled(IconHeatmapSVG)`
  margin-right: 8px;
  width: 18px;
  height: 18px;
  path {
    fill: ${(props) => props.theme.colors.purple3};
  }
`;
export const IconUserflow = styled(IconUserflowSVG)`
  margin-right: 8px;
  width: 18px;
  height: 18px;
  path {
    fill: ${(props) => props.theme.colors.purple3};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const HeaderRightWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  input {
    font-family: 'RobotoR', 'NotoKrR';
    width: 270px;
    height: 34px;
    padding: 8px 48px 8px 16px;
    border-radius: 17px;
    border: solid 1px ${(props) => props.theme.colors.grey200};
    font-size: 12px;
    color: ${(props) => props.theme.colors.grey700};

    &:focus {
      color: ${(props) => props.theme.colors.grey800};
      outline: none;
      border-color: ${(props) => props.theme.colors.grey800};
    }

    ::placeholder {
      color: ${(props) => props.theme.colors.grey500};
    }
  }
`;

export const PageViewSortWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const PageViewSortTitle = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 12px;
  line-height: 1.75;
  height: 17px;
  color: ${(props) => props.theme.colors.grey500};
`;

export const PageViewSortIcon = styled.div`
  margin-left: 4px;
`;

export const PageCardWrapper = styled.div`
  background-color: white;
  height: 396px;
  border-radius: 8px;
  overflow: hidden;
`;

export const PageCardHover = styled.div`
  position: absolute;
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);

  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

export const PagecardHoverButton = styled(Link)`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  line-height: 1.43;
  color: ${(props) => props.theme.colors.purple3};
  display: flex;
  align-items: center;
  opacity: 1 !important;
  background: ${(props) => props.theme.colors.primary};
  border-radius: 8px;
  width: 150px;
  height: 35px;
  margin-bottom: 8px;
  padding-left: 16px;

  :hover {
    ${IconHeatmap} {
      path {
        fill: white;
      }
    }
    ${IconUserflow} {
      path {
        fill: white;
      }
    }
    color: white;
  }

  z-index: 3;
`;

export const PageCardThumbnail = styled.div`
  position: relative;
  height: 291px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 0%;
  }
  :hover {
    ${PageCardHover} {
      display: flex;
    }
  }
`;

export const PageCardInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  height: 105px;
  padding: 16px 24px;
`;

export const PageCardTitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const PageCardTitleText = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  color: ${(props) => props.theme.colors.grey800};
  line-height: 1.79;
`;

export const PageCardURL = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  color: ${(props) => props.theme.colors.grey500};
  line-height: 1.79;
`;

export const PageMoreButton = styled.div`
  width: 4px;
  height: 16px;
`;

export const MoreIcon = styled(IconMoreSVG)`
  width: 4px;
  height: 16px;
`;

export const PaginationWrapeer = styled.div`
  /* width: 324px; */
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 160px;
  margin-top: 80px;
`;

export const PaginationCustom = styled(Pagination)`
  .MuiPaginationItem-root {
    height: 36px;
    width: 36px;
    margin: 0px;
    font-family: 'RobotoR', 'NotoKrR';
    font-weight: normal;
    color: ${(props) => props.theme.colors.grey600};
    font-size: 16px;
    line-height: 1.5;
  }
  .MuiPaginationItem-page.Mui-selected {
    background-color: #7851e7;
    color: white;
  }
`;

export const SpinnerWrapper = styled.div`
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DataError = styled.div`
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  line-height: 1;
  color: ${(props) => props.theme.colors.grey800};
`;

export const PageThumbnailImageSplit = styled.div`
  width: 100%;
  height: 1px;
  padding: 0px 24px 0px 24px;
  div {
    width: 100%;
    height: 1px;
    background-color: ${(props) => props.theme.colors.grey200};
  }
`;
